export default "__VITE_ASSET__DnhJTIHS__"